import{clsx as e}from"clsx";import{twMerge as t}from"tailwind-merge";function o(...r){return t(e(r))}var m=o;export{o as cn,m as default};
//# sourceMappingURL=index.js.map